"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PathTooltip = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
exports.PathTooltip = props => {
  const _react_1$useState = react_1.useState(true),
    _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
    hidden = _react_1$useState2[0],
    setHidden = _react_1$useState2[1];
  const _react_1$useState3 = react_1.useState({
      x: 0,
      y: 0,
      w: 0,
      h: 0,
      isLeft: false,
      isTop: false
    }),
    _react_1$useState4 = _slicedToArray(_react_1$useState3, 2),
    tooltipRect = _react_1$useState4[0],
    setTooltipRect = _react_1$useState4[1];
  const _react_1$useState5 = react_1.useState(props["fontSize"] || 12),
    _react_1$useState6 = _slicedToArray(_react_1$useState5, 1),
    fontSize = _react_1$useState6[0];
  const _react_1$useState7 = react_1.useState(props["fontFamily"] || "sans-serif"),
    _react_1$useState8 = _slicedToArray(_react_1$useState7, 1),
    fontFamily = _react_1$useState8[0];
  const _react_1$useState9 = react_1.useState(props["bgColor"] || "black"),
    _react_1$useState10 = _slicedToArray(_react_1$useState9, 1),
    bgColor = _react_1$useState10[0];
  const _react_1$useState11 = react_1.useState(props["textColor"] || "white"),
    _react_1$useState12 = _slicedToArray(_react_1$useState11, 1),
    textColor = _react_1$useState12[0];
  const _react_1$useState13 = react_1.useState(props["rtl"] || false),
    _react_1$useState14 = _slicedToArray(_react_1$useState13, 1),
    rtl = _react_1$useState14[0];
  const pathRef = props.pathRef;
  const svgRef = props.svgRef;
  const textRef = react_1.createRef();
  react_1.useEffect(() => {
    const updateTooltip = e => {
      if (svgRef && pathRef && textRef && svgRef.current && pathRef.current && textRef.current) {
        const svgRect = svgRef.current.getBoundingClientRect();
        const textRect = textRef.current.getBoundingClientRect();
        const isLeft = e.x - svgRect.x > svgRect.width / 2;
        const isTop = e.y - svgRect.y > svgRect.height / 2;
        const w = textRect.width + 20;
        const h = textRect.height + 20;
        const x = isLeft ? e.x - svgRect.x + 8 - w : e.x - svgRect.x - 8;
        const y = isTop ? e.y - svgRect.y - 12 - h : e.y - svgRect.y + 8;
        setTooltipRect({
          x: x,
          y: y,
          w: w,
          h: h,
          isLeft: isLeft,
          isTop: isTop
        });
      }
    };
    if (pathRef && pathRef.current) {
      pathRef.current.addEventListener('mouseover', () => {
        setHidden(false);
      });
      pathRef.current.addEventListener('mouseleave', () => {
        setHidden(true);
      });
      pathRef.current.addEventListener('mousemove', e => {
        if (!hidden) updateTooltip(e);
      });
    }
  }, [pathRef, svgRef, textRef, hidden]);
  const bottomRight = (tooltipRect.x + 7).toString() + "," + (tooltipRect.y - 10).toString() + " " + (tooltipRect.x + 30).toString() + "," + tooltipRect.y.toString() + " " + (tooltipRect.x + 22).toString() + "," + tooltipRect.y.toString();
  const bottomLeft = (tooltipRect.x + tooltipRect.w - 8).toString() + "," + (tooltipRect.y - 10).toString() + " " + (tooltipRect.x + tooltipRect.w - 25).toString() + "," + tooltipRect.y.toString() + " " + (tooltipRect.x + tooltipRect.w - 15).toString() + "," + tooltipRect.y.toString();
  const topRight = (tooltipRect.x + 7).toString() + "," + (tooltipRect.y + tooltipRect.h + 10).toString() + " " + (tooltipRect.x + 15).toString() + "," + (tooltipRect.y + tooltipRect.h).toString() + " " + (tooltipRect.x + 7).toString() + "," + (tooltipRect.y + tooltipRect.h).toString();
  const topLeft = (tooltipRect.x + tooltipRect.w - 7).toString() + "," + (tooltipRect.y + tooltipRect.h + 10).toString() + " " + (tooltipRect.x + tooltipRect.w - 15).toString() + "," + (tooltipRect.y + tooltipRect.h).toString() + " " + (tooltipRect.x + tooltipRect.w - 7).toString() + "," + (tooltipRect.y + tooltipRect.h).toString();
  const points = tooltipRect.isLeft && tooltipRect.isTop ? topLeft : tooltipRect.isTop ? topRight : tooltipRect.isLeft ? bottomLeft : bottomRight;
  const findSpaceBeforeThreshold = (inputString, threshold) => {
    let i = 0;
    let temp = -1;
    if (inputString.length <= threshold) {
      return ["", inputString];
    }
    while (i <= inputString.length && i <= threshold) {
      if (inputString[i] === " ") {
        temp = i;
      }
      i++;
    }
    return temp !== -1 ? [inputString.slice(0, temp), inputString.slice(temp + 1)] : [inputString.slice(0, threshold), inputString.slice(threshold + 1)];
  };
  const tips = [];
  const startTip = findSpaceBeforeThreshold(props.tip, 35 - (1 * fontSize - 11));
  tips.push(startTip[0]);
  let interimTip = startTip[1];
  let leftover = startTip[1];
  while (interimTip !== "") {
    const currTip = findSpaceBeforeThreshold(interimTip === leftover ? interimTip : leftover, 35 - (1 * fontSize - 11));
    interimTip = currTip[0];
    leftover = currTip[1];
    tips.push(interimTip === "" ? currTip[1] : currTip[0]);
  }
  return react_1.default.createElement("g", {
    pointerEvents: "none"
  }, react_1.default.createElement("rect", {
    x: tooltipRect.x,
    y: tooltipRect.y,
    width: tooltipRect.w,
    rx: 5,
    ry: 5,
    height: tooltipRect.h,
    fill: bgColor,
    visibility: hidden ? "hidden" : "visible"
  }), react_1.default.createElement("polygon", {
    fill: bgColor,
    visibility: hidden ? "hidden" : "visible",
    points: points
  }), react_1.default.createElement("text", {
    ref: textRef,
    x: rtl ? tooltipRect.x + tooltipRect.w - 10 : tooltipRect.x + 10,
    y: tooltipRect.y,
    cursor: "default",
    fontFamily: fontFamily,
    fontSize: fontSize,
    fill: textColor,
    visibility: hidden ? "hidden" : "visible"
  }, props.tip.length > 35 - 1 * (fontSize - 11) ? tips.map((tip, index) => {
    return react_1.default.createElement("tspan", {
      key: tip,
      x: rtl ? tooltipRect.x + tooltipRect.w - 10 : tooltipRect.x + 10,
      y: tooltipRect.y + (20 + (1 * fontSize - 11)) + 20 * index
    }, tip);
  }) : react_1.default.createElement("tspan", {
    x: rtl ? tooltipRect.x + tooltipRect.w - 10 : tooltipRect.x + 10,
    y: tooltipRect.y + (20 + (1 * fontSize - 11))
  }, props.tip)));
};